import React from 'react';
import { observer } from "mobx-react-lite";
import AvailabilityCalendar from "./availability-calendar";


const TimeslotManagement: React.FC = observer(() => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden flex flex-col h-full">
      <div className="flex-1 overflow-hidden">
          <AvailabilityCalendar />
      </div>
    </div>
  );
});

export default TimeslotManagement;
